export default __webpack_public_path__ + "static/media/modernArt.0b40319d.png";